import TableRequestDTO from '../../../models/TableRequestDTO';
import { DataTableButton, DataTableButtonType, ExportButton, ResetButton } from './DataTable';

class DataTableButtonUtil {
  public static Default(label: string, onClick: () => void) {
    const button: DataTableButton = {
      dataTableButtonType: DataTableButtonType.Generic,
      label,
      onClick
    };
    return button;
  }

  public static Primary(label: string, onClick: () => void) {
    const button: DataTableButton = {
      dataTableButtonType: DataTableButtonType.Generic,
      label,
      onClick,
      type: 'primary'
    };
    return button;
  }

  public static Danger(label: string, onClick: () => void) {
    const button: DataTableButton = {
      dataTableButtonType: DataTableButtonType.Generic,
      label,
      onClick,
      danger: true
    };
    return button;
  }

  public static Export(exportHandler: (tableState: TableRequestDTO) => any, loading?: boolean) {
    const button: ExportButton = {
      dataTableButtonType: DataTableButtonType.Export,
      label: 'Export',
      export: exportHandler,
      loading,
      disabled: loading
    };
    return button;
  }

  public static Reset() {
    const button: ResetButton = {
      dataTableButtonType: DataTableButtonType.Reset,
      label: 'Reset'
    };
    return button;
  }

  /*
  public static Link(label: string, to: string) {
    const button: LinkButton = {
      dataTableButtonType: DataTableButtonType.Link,
      label,
      to
    };
    return button;
  }
  */
}

export default DataTableButtonUtil;